import { Feature } from '@wwt/entities/search-response'

import { getWWTSortedFeatures } from '../features/getWWTSortedFeatures'

/**
 *
 * @param features - Array of features
 * @param optionPriority - If true, sort by selected option priority if exists.
 * 												 Is false, sort by feature priority
 * @param countForSlice
 */
export const sortFeatures = (
	features: Feature[],
	optionPriority = true,
	countForSlice: number | undefined = undefined
) => {
	const sortedFeatures = getWWTSortedFeatures(features, optionPriority)

	if (countForSlice !== undefined) {
		return sortedFeatures.slice(0, countForSlice)
	}

	return sortedFeatures
}
